var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'radio-group',
    _vm.themeClass
]},_vm._l((_vm.options),function(option){return _c('Radio',{key:option.value,attrs:{"name":_vm.name,"label":option.label,"value":option.value,"is-checked":option.value === _vm.selected},on:{"click":_vm.onClickRadio}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }